let clickCount = 0;
const addToCartbutton = document.getElementById('btnAddToCart_SCProdOpts');
const modal = document.getElementById('myModal');
const modalTitle = document.getElementById('modalTitle');
const modalMessage = document.getElementById('modalMessage');
const okButton = document.getElementById('okButton');
var previousValue;

function showModal(title, message) {
    modalTitle.textContent = title;
    modalMessage.textContent = message;
    modal.style.display = 'block';
}

addToCartbutton.addEventListener('click', function() {
    clickCount++;
    console.log("Current Value: " + document.querySelector('input[name="properties[Case ID]"]').value);
    if (clickCount > 1 && previousValue === document.querySelector('input[name="properties[Case ID]"]').value) {
        addToCartbutton.setAttribute("disabled", true);
        showModal('Message', 'To place an additional order, please resubmit RX');
    }
    else {
        previousValue = document.querySelector('input[name="properties[Case ID]"]').value;
        console.log("Previous Value: " + previousValue);
    }
});

okButton.onclick = function() {
    modal.style.display = 'none';
    setTimeout(function(){location.reload();}, 500);
}

